import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "./assets/bg1.png"

const Emergency = ({ userId }) => {
  // alert(userId)
  // Define Yup schema for form validation
  const schema = yup.object().shape({
    Blood_Group: yup.string().required("Blood Group is required"),

    Contact_Person_in_case_of_Emergency: yup
      .number()
      .typeError("Contact No. must be a number") // Handle type errors
      .required("Emergency Contact Number is required") // Field is required
      .integer("Contact No. must be an integer") // Must be an integer
      .test(
        "len",
        "Contact No. must be exactly 10 digits",
        (val) => val && String(val).length === 10
      ),
    Contact_Person_Name: yup.string().required("Emergency Contact Person is required"),
    // Phone: yup.string().required("Phone is required"),
  });

  // Initialize useForm hook with validation resolver
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("No token found, please login again.");
      navigate("/SignInCandidate");
    }
  }, [navigate]);

  // Function to handle form submission
  const onSubmit = async (formData) => {
    try {
      const finalObj = { ...formData, userId };
      const token = localStorage.getItem("token");

      if (!token) {
        toast.error("user unauthorized.");
        return;
      }

      const response = await fetch(
        "   http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/EmergencyDetails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(finalObj),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();

      toast.success("Emergency Details Submitted Successfully!", {
        position: "top-center",
        transition: Slide,
      });

      reset(); // Reset form after successful submission
      setTimeout(() => {
        navigate("/EnteryCandidatePortel/document");
      }, 2000); // 1 second delay
    } catch (error) {
      toast.error("Error submitting Emergency Details. Please try again.");
      console.error("Error submitting Emergency Details:", error);
    }
  };

  return (
    <>
      <div 
       className="w-full flex items-center justify-center"
       style={{
         backgroundImage: `url(${bgImage})`,
         backgroundSize: "cover",
         backgroundPosition: "center",
         backgroundRepeat: "no-repeat",
         minHeight: "100vh",
       }}>
      <ToastContainer transition={Slide} />
      <form onSubmit={handleSubmit(onSubmit)}  className="max-w-4xl mx-auto p-6 md:p-10 bg-white shadow-lg rounded-lg">
        {/* Form fields */}
        <h1 className="w-full text-2xl md:text-3xl font-serif font-bold text-center my-6 text-indigo-600 mt-3">
        EMERGENCY DETAILS
      </h1>
      <div className="border-b-2 border-indigo-400 my-4 mx-auto w-11/12 md:w-2/3"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
          {/* Contact Person Name */}
          <div className="space-y-2">
            <label className="block text-lg font-serif font-semibold text-gray-700">
            Emergency Contact Person
            </label>
            <input
              type="text"
              {...register("Contact_Person_Name")}
              placeholder="Enter full name"
              className={`w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
                errors.Contact_Person_Name
                  ? "border-red-500"
                  : "focus:border-indigo-400"
              }`}
            />
            {errors.Contact_Person_Name && (
              <p className="text-red-500 text-sm mt-1">
                {errors.Contact_Person_Name.message}
              </p>
            )}
          </div>

          {/* Blood Group */}
          <div className="space-y-2">
            <label className="block text-lg font-serif font-semibold text-gray-700">
              Blood Group
            </label>
            <input
              type="text"
              {...register("Blood_Group")}
              placeholder="Enter your blood group"
              className={`w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
                errors.Blood_Group
                  ? "border-red-500"
                  : "focus:border-indigo-400"
              }`}
            />
            {errors.Blood_Group && (
              <p className="text-red-500 text-sm mt-1">
                {errors.Blood_Group.message}
              </p>
            )}
          </div>
        </div>

        {/* Contact Number in case of Emergency */}
        <div className="mt-6">
          <div className="space-y-2">
            <label className="block text-lg font-serif font-semibold text-gray-700">
            Emergency Contact Number
            </label>
            <input
              type="text"
              {...register("Contact_Person_in_case_of_Emergency")}
              placeholder="Enter emergency contact number"
              className={`w-full px-4 py-3 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-400 ${
                errors.Contact_Person_in_case_of_Emergency
                  ? "border-red-500"
                  : "focus:border-indigo-400"
              }`}
            />
            {errors.Contact_Person_in_case_of_Emergency && (
              <p className="text-red-500 text-sm mt-1">
                {errors.Contact_Person_in_case_of_Emergency.message}
              </p>
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="flex justify-center mt-10">
          <button
            type="submit"
            className="w-35 py-2 px-6 bg-indigo-600 text-white font-semibold text-lg rounded-lg shadow-md hover:bg-cyan-900 transition duration-300"
          >
            Submit
          </button>
        </div>
      </form>
      </div>

    </>
  );
};

export default Emergency;
